module.exports = __webpack_public_path__ + "img/apikeys.ec289eaa.svg";